<template>
  <fieldset>
    <legend>Location</legend>

    <div class="location-container container-hor">
      <div class="location-div">
        <fieldset>
          <legend>Address</legend>
          <div class="container-hor">
            <div class="address-div">
              <Form-input v-model="streetAddress" :name="'street address:'"></Form-input>
              <Form-input v-model="city" :name="'city:'"></Form-input>
              <ProvinceSelect v-model:selected="province" />
            </div>
            <div class="big-btn-div">
              <button class="big-btn" type="button" @click="lookupGPS">Search Address</button>
              <!--<FormBtn :disabled="searchButtonDisabled" :name="'Search'" @clicked="lookupGPS"></FormBtn>-->
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>GPS</legend>
          <div class="container-hor">
            <div class="gps-div">
              <!--Form-input v-model="googleAddress" :name="'Address from Google:'"></Form-input>-->
              <Form-input v-model="gps.lat" :name="'lat:'" :type="'Number'"></Form-input>
              <Form-input v-model="gps.lon" :name="'lon:'" :type="'Number'"></Form-input>
            </div>
            <!--<div class="big-btn-div container-hor gps-btn-div">-->
            <div class="gps-btn" style="display: none">
              <button class="big-btn" type="button" @click="update" disabled>Set to GPS Coordinates</button>
            </div>
            <!--  <FormBtn :disabled="updateBtnState" :name="'Set to GPS'" @clicked="update"></FormBtn>-->
            <div class="gps-btn">
              <button v-if="picking" class="big-btn" type="button" @click="cancelPick">
                Cancel Pick
              </button>
              <button v-else class="big-btn" type="button" @click="pickFromMap">
                Pick Point from Map
              </button>
              <!--<FormBtn v-if="picking" :name="'Cancel Pick'" @clicked="cancelPick"></FormBtn>-->
              <!--FormBtn v-else :name="'Pick Point'" @clicked="pickFromMap"></FormBtn-->
            </div>
            <!-- </div>-->
          </div>
        </fieldset>

        <ClimaticForm
          v-model:climatic-site="climaticSite"
          v-model:siteOptions="nearestSites"
        ></ClimaticForm>
    
      </div>

      <!--Suspense>
        <template #default-->
          <div class="map-div">
            <project-map
              v-model:gps="gps"
              :picking="picking"
              :popupStr="projectName"
              :nearestSites="nearestSites"
              :nearestProjects="nearestProjects"
              @mapClicked="pickedGPS"
              
              :mapKey="mapKey"
              v-model:zoom="mapZoom"
            ></project-map>
          </div>
        <!--/template>
        <template #fallback>
          <div id="map-loading">
            <span>Loading Map...</span>
          </div>
        </template>
      </Suspense-->
    </div>
    <div class="debug">
      <p><b>Debuggin Project-location.vue:</b></p>
      <p>nearest sites = {{ nearestSites }}</p>
      <p>mapZoom = {{ mapZoom }}</p>
      <p>projectName = {{ projectName }}</p>
      <p>streetAddress = {{ streetAddress }}</p>
      <p>city = {{ city }}</p>
      <p>province = {{ province }}</p>
      <p>gps = {{ gps }}</p>
      <p>mapKey = {{ mapKey }}</p>
      <p>picking = {{ picking }}</p>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
//asynchronous component:

import ProvinceSelect from './Province-select.vue'
import FormInput from './form/Form-input.vue'
import FormBtn from './form/Form-btn.vue'
import ProjectMap from './Project-map.vue'
import { Province } from '@/types/types'
import { ref, watch, computed } from 'vue'
import { useClimaticStore, useProjectStore } from '@/stores'
import { fetchGPS } from '@/libs/climatic'
import ClimaticForm from './Climatic-form.vue'
import router from '@/router'

const projectName = defineModel<String | null>('projectName', { required : true})
const streetAddress = defineModel<String | null>('streetAddress', { required: true })
const city = defineModel<String | null>('city', { required: true })
const province = defineModel<Province>('province', { required: true })
const gps = defineModel<Object>('gps', { required: true, default: { lat: -1, lon: -1 } });
const climaticSite = ref();
const climaticStore = useClimaticStore();
const projectStore = useProjectStore();
const nearestSites = ref([])
const nearestProjects = ref([]);

/**
 * based on gps and province, update the arrays of nearest 100 jobs 
 * and nearest 5 climatic sites
 */
async function refreshNearestSites(){
  console.log("Project-location.refreshNearestSites()...");
  try{
    nearestSites.value = await climaticStore.getNearestSites(
      province.value,
      gps.value.lat,
      gps.value.lon,
      5
    );
  climaticSite.value = nearestSites.value[0];
  }catch(err){
    console.error("..Project-location error in refreshNearestSites.." + err);
    nearestSites.value = ['empty'];
    climaticSite.value = null;
  }
  nearestProjects.value = await projectStore.getNearestSites(
    //{'project' : {
      {'gps':{
        'lat' : gps.value.lat, 
        'lon' : gps.value.lon 
      }
      }, 100
  )  
}

await refreshNearestSites();
const emits = defineEmits(['updateGPS']) //TODO remove?
const picking = ref(false) //state of map picking gps
const mapKey = ref(1);  //update to refresh/redraw map
const searchButtonDisabled = ref(false)
const updateBtnState = ref(false) //TODO updateBTn isn't really needed?
const mapZoom = ref(13) //this will keep the zoom level same when map is re-rendered

watch(gps, async ()=>{
  //emits('updateGPS');
  //only call update if both lat and lon are valid:
  const lat = parseFloat(gps.value.lat);
  const lon = parseFloat(gps.value.lon);
  //console.log(`..project location gps watch, checking if lat and lon are valid: ${lat}, ${lon} : types = ${typeof(lat)}, ${typeof(lon)}`)
  if(lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180){
    //console.log("..lat and lon are valid, updating map..");
    await update();
  }else{
    console.log("..invalid lat and lon, do not update map...");
  }

  //efreshNearestSites();
  //redrawMap();
},
{deep : true})

watch(province, async ()=>{
  await update();
  //refreshNearestSites();
  //redrawMap();
})

/**
 * this will tell the project-map compoment to redraw / refresh itself
 */
function redrawMap(){
  console.log("Project-location.redrawMap()...");
  mapKey.value = mapKey.value + 1;
}


/**
 * Backend custom api/wrapper around google map search
 */
async function lookupGPS() {
  //loadingStart();
  console.log('Project-location.lookupGPS()...')
  const address = streetAddress.value + ', ' + city.value + ', ' + province.value
  //const googleFetched = await fetchGPS(address);
  //gps.value = {'lat': googleFetched.lat, 'lon':  googleFetched.lon};
  try{
    gps.value = await fetchGPS(address)
    /*let min=-180;
    let max=180;
    let lat = Math.random()*min + Math.random()*max;
    let lon = Math.random()*min + Math.random()*max;
    gps.value = {'lat': lat, 'lon': lon};*/
    //mapKey.value += 1
  }catch(error){
    console.log("..error in fetchGPS...");
    console.log(error);
    gps.value = {'lat': -2, 'lon': -2};
  }
  await update();
}

/**
 * update the map data and tell map to redraw itself
 */
async function update() {
  console.log('updating GPS......')
  picking.value = false
  await refreshNearestSites();
  redrawMap();
}

function pickFromMap() {
  console.log('Project-location pickFromMap clicked...')
  picking.value = true;
  //updateBtnState.value = true;
  // searchButtonDisabled.value = true;
  mapKey.value += 1
}

//from map click
async function pickedGPS(latlng) {
  console.log('update project gps to be :' + latlng)
  gps.value.lat = latlng.lat
  gps.value.lon = latlng.lng
  //redrawMap();
  await update();
  //mapKey.value += 1;

  // picking.value = false;
}

//cancel pick, revert to previous, as in reload route
function cancelPick() {
  console.log('Project-location cancel pick..')
  console.log('...doing nothing')
  //this.$router.go(0);
  router.go(0)
}

watch(picking, async (newValue, oldValue) => {
  if (newValue == true) {
    searchButtonDisabled.value = true
  } else {
    searchButtonDisabled.value = false
  }
})
</script>

<style lang="css" scoped>
.location-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.location-div {
  /* flex-basis: 20rem;*/
  flex-grow: 1;
  width: 40%;
}

.map-div {
  flex-grow: 4;
  width: 60%;
}

.map-loading {
  flex-grow: 4;
  width: 60%;
}

.btn-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
  padding-right: 1rem;
  margin-bottom: 1rem;
}

#map-loading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 600px;
  width: 100%;
  display: block;
  border: 1px solid var(--blue);
  border-radius: 0.5rem;
  margin: 2rem;
  background-color: rgba(0, 0, 0, 0.4);
}

.address-div,
.gps-div {
  /*flex-grow: 4;*/
  width: 70%;
  /*min-width: 25rem;*/
}

.big-btn-div {
  /* flex-grow: 1;*/
  width: 30%;
  /* width:100%;*/
}

button.big-btn {
  display: block;
  width: 100%;
  height: 100%;
  background-color: var(--blue);
}

.gps-btn-div {
  width: 100%;
}
.gps-btn {
  width: 15%;
}
</style>
